<template>
  <v-app id="app">
    <JcdcSessionTimeout
      v-if="$store.state.accessToken"
      :app-environment="$store.state.appEnvironment"
      @inactive-logout="logout()"
    />
    <!-- Form for user testing. Set v-if to true if you'd like to quickly switch between users without going through the login and authentication. - MN -->
    <JcdcTestingModal
      v-if="false"
      :logged-in="loggedIn"
      :entra-user="$store.getters.displayName"
      :user-info="$store.state.adName"
      :app-environment="$store.state.appEnvironment"
      @search-click="tempTestAdUser($event)"
      @logout-click="logout()"
      @login-click="login()"
    />
    <!-- Page Template -->
    <JcdcLoadingPage v-if="$store.state.loadingApp" />
    <router-view />
    <JcdcFlashMessage
      :type="$store.state.responseType"
      :text="$store.state.responseMessage"
      :timeout="$store.state.msgTimeout"
    />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  JcdcFlashMessage,
  JcdcLoadingPage,
  JcdcSessionTimeout,
  JcdcTestingModal,
} from '@/components/jcdc/index.ts'
import { signIn, signOut } from '@/services/entraAuth'

export default {
  name: 'App',
  components: {
    JcdcFlashMessage,
    JcdcLoadingPage,
    JcdcSessionTimeout,
    JcdcTestingModal,
  },
  computed: {
    ...mapGetters(['loggedIn']),
  },
  methods: {
    ...mapActions(['tempTestAdUser']),
    login() {
      signIn()
    },
    logout() {
      signOut()
    },
    errorFlash(e) {
      this.$store.commit('SET_RESPONSE_TYPE', 'error')
      this.$store.commit('SET_RESPONSE_MSG', e)
    },
  },
}
</script>
